import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { loadRules } from "@/lib/rules";
import AppSidebar, { PAGE_TITLES } from "@/components/AppSidebar";
import GlobalProgressBar from "@/components/GlobalProgressBar";
import { Menu } from "lucide-react";

export default function AppShell({ children }) {
  useEffect(() => { loadRules(); }, []);
  const [collapsed, setCollapsedRaw] = useState(() => {
    try { const v = localStorage.getItem("sidebar_collapsed"); return v == null ? window.innerWidth < 1500 : v === "1"; } catch { return false; }
  });
  const setCollapsed = (fn) => setCollapsedRaw((c) => {
    const n = typeof fn === "function" ? fn(c) : fn;
    try { localStorage.setItem("sidebar_collapsed", n ? "1" : "0"); } catch {}
    return n;
  });
  const [mobileOpen, setMobileOpen] = useState(false);
  const loc = useLocation();
  const title = PAGE_TITLES[loc.pathname] || "人客多";

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900">
      <GlobalProgressBar />
      <AppSidebar collapsed={collapsed} setCollapsed={setCollapsed} mobileOpen={mobileOpen} setMobileOpen={setMobileOpen} />
      <div className={`transition-all ${collapsed ? "md:ml-[64px]" : "md:ml-[220px]"}`}>
        {/* Top bar */}
        <header className="sticky top-0 z-20 h-11 bg-white/95 backdrop-blur border-b border-slate-200" data-testid="app-topbar">
          <div className="h-full px-4 lg:px-5 flex items-center justify-between gap-3">
            <div className="flex items-center gap-3">
              <button
                data-testid="topbar-hamburger"
                onClick={() => setMobileOpen(true)}
                className="md:hidden h-9 w-9 inline-flex items-center justify-center rounded-md hover:bg-slate-100 text-slate-700"
                aria-label="開啟選單"
              >
                <Menu className="h-5 w-5" />
              </button>
              <h1 className="text-base sm:text-lg font-semibold text-slate-900" data-testid="topbar-page-title">
                {title}
              </h1>
            </div>
            <div className="flex items-center gap-3">
              <div
                className="h-8 w-8 rounded-full bg-[#FEF3E8] text-[#C04C0F] font-semibold text-sm flex items-center justify-center"
                aria-label="使用者"
                data-testid="topbar-avatar"
              >
                L
              </div>
            </div>
          </div>
        </header>

        <main className="px-3 sm:px-4 lg:px-5 py-4 max-w-full overflow-x-clip" data-testid="app-main">
          {children}
        </main>
      </div>
    </div>
  );
}
